import React from 'react'
import { Route, Switch } from 'react-router-dom'

import Container from '../Container'
import List from './List'
import Create from './Create'
import Update from './Update'
import Actions from '../Actions'

import routes from '../../constants/routes'
import toast from '../../utils/toast'

class Beacons extends React.PureComponent {
  state = {
    filterable: false
  }

  _onNewClick = () =>
    this.props.history.push(routes.NEW_BEACON)

  _goToUpdate = (data) =>
    this.props.history.push(routes.goToBeacon(data.id))

  _getId = () => {
    const paths = this.props.location.pathname.split('/')
    return paths[2]
  }

  _onCompleted = data =>
    toast.info('Beacon was successfully saved', this.props.history.push(routes.BEACONS))

  _onError = (message = 'Oops, an error occurred!') =>
    toast.error(message)

  _toggleFilter = () =>
    this.setState({filterable: !this.state.filterable})

  render () {
    return (
      <Container>
        <Switch>
          <Route exact path={routes.BEACONS} render={() => <Actions onCreate={this._onNewClick} onFilter={this._toggleFilter} />} />
        </Switch>
        <Switch>
          <Route exact path={routes.BEACONS} render={() => <List onRowClick={this._goToUpdate} filterable={this.state.filterable} />} />
          <Route exact path={routes.NEW_BEACON} render={() => <Create onCompleted={this._onCompleted} onError={this._onError} />} />
          <Route exact path={routes.UPDATE_BEACON} render={() => <Update id={this._getId()} onCompleted={this._onCompleted} onError={this._onError} />} />
        </Switch>
      </Container>
    )
  }
}

export default Beacons


// WEBPACK FOOTER //
// ./src/components/Beacons/Beacons.js